import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getPrizeList } from "../../../features/slices/challanges";
import CommonPagination from "../../CommonPagination";
import moment from "moment";
import { canPerformAction } from "../../../utils/denyAccess";
const initialState = {};
const ViewPrizeDetail = () => {
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const dispatch = useDispatch();
  const { prizeList, loading } = useSelector((state) => {
    return state.challenges;
  });

  useEffect(() => {
    dispatch(getPrizeList());
  }, []);
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox justify-content-end">
          {canPerformAction("Challenges&Bounty") && (
            <Link to={"/challenges/addPrize"} className="TitleLink">
              <i className="fa-solid fa-plus" /> Add New Prize
            </Link>
          )}
        </div>
        <div className="Small-Wrapper">
          <div className="TableList">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Prize Id</th>
                  <th>Prize Name</th>
                  <th>Last Submission Date</th>
                  <th>Prize No.</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {prizeList?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1}</td>
                      <td>{res?.prizeId}</td>
                      <td>{res?.name}</td>
                      <td>{moment(res?.createdAt).format("DD/MM/YYYY")}</td>
                      <td>{res?.prizeNo}</td>
                      <td>
                        <div className="Actions">
                          {canPerformAction("Challenges&Bounty") && (
                            <Link
                              to={"/challenges/editPrize"}
                              className="Edit"
                              state={res}
                            >
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                          )}
                          <Link
                            to={"/challenges/viewPrize"}
                            className="Eyes"
                            state={res}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {prizeList?.result?.[0]?.paginationData?.length + (page - 1) * 10}{" "}
              of {prizeList?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {prizeList?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    prizeList?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ViewPrizeDetail;
